/* eslint arrow-body-style: */
import { getBrandInfo as getBrandInfoAsync } from 'api/BrandInfo';
import { isCancel, mustRefetch } from 'api/Helpers';
import config from 'shared/config';
import { CLEAR_FETCH_ERROR, IS_FETCHING, FETCH_ERROR, RECEIVE_BRAND_INFO } from './constants';

const clearFetchError = () => ({
	type: CLEAR_FETCH_ERROR,
});

const updateFetchStatus = isFetching => ({
	type: IS_FETCHING,
	isFetching,
});

const updateFetchError = fetchError => ({
	type: FETCH_ERROR,
	fetchError,
});

const receiveBrandInfo = (brandInfo, cacheable) => {
	// Only store the last fetch time if the response has marked this data cacheable
	// An undefined lastFetchTime will always trigger a refetch
	const lastFetchTime = cacheable ? Date.now() : undefined;

	return {
		type: RECEIVE_BRAND_INFO,
		brandInfo,
		lastFetchTime,
	};
};

// Thunks

/**
 * Get settings that client's use to customize the kiosk
 * @param {axios cancel token} cancelToken
 */
const getBrandInfo = cancelToken => {
	return (dispatch, getState) => {
		// This data does not need to be refetched if we already have it in our store.
		const { brandInfo } = getState();
		const { lastFetchTime } = brandInfo.get('brandInfo');
		if (!mustRefetch(lastFetchTime, config.MAX_BRAND_INFO_CACHE_TIME)) {
			return false;
		}

		dispatch(updateFetchStatus(true));

		return getBrandInfoAsync(cancelToken)
			.then(response => {
				dispatch(updateFetchStatus(false));
				dispatch(receiveBrandInfo(response.data.brandInfo, response.data.cacheable));
			})
			.catch(error => {
				dispatch(updateFetchStatus(false));
				if (isCancel(error)) {
					// Request was cancelled.
					return;
				}

				dispatch(updateFetchError(error));
			});
	};
};

export {
	clearFetchError,
	getBrandInfo,
	receiveBrandInfo,
	updateFetchError,
	updateFetchStatus,
};
